module.exports = __webpack_public_path__ + "img/popular-categories-4.6187d1f5.png";